import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useSoccerResult, useBasketballResult, useCricketResult } from './useMatchData';
import getLastWeek from '../../utils/getLastWeek';
import { LiveScoreDisplayCount, sportList } from './liveScoreConstants';
import { LiveScoreCardResult } from './LiveScoreCardResult';
import Week from './Week';
import EmptyMatch from './EmptyMatch';
import LiveScoreGroup from './LiveScoreGroup';
import PreLoader from '../common/PreLoader';

const SoccerResult = ({ selectedTime, selectedSport }) => {
    const { lastWeek } = getLastWeek();
    const { soccerResult, isResultLoading } = useSoccerResult(
        selectedTime[0] || lastWeek[0].month,
        selectedTime[1] || lastWeek[0].date,
    );

    if (isResultLoading) {
        return <PreLoader />;
    }

    if (!soccerResult) {
        return <EmptyMatch />;
    }

    return (
        <LiveScoreGroup selectedSport={selectedSport}>
            {soccerResult
                ?.Result?.Match
                ?.filter((result) => result?.HomeTeam.NameEn && result?.AwayTeam.NameEn
                    && result?.HomeTeam.Icon && result?.AwayTeam.Icon)
                ?.filter(
                    (result) => (
                        // soccer, cricket的比賽狀態是 Status
                        // basketball 的比賽狀態是 MatchStatus
                        result.Status === 50 || result.MatchStatus === 50 || result.Status === 2
                    ),
                )
                ?.slice(0, LiveScoreDisplayCount)
                ?.map((data, soccerIndex) => {
                    const key = `${data.MatchId}-${soccerIndex}`;
                    return (
                        <LiveScoreCardResult
                            key={key}
                            selectedSport="Soccer"
                            sportData={data}
                            isResult
                        />
                    );
                })}
        </LiveScoreGroup>
    );
};
const BasketballResult = ({ selectedTime, selectedSport }) => {
    const { lastWeek } = getLastWeek();
    const { basketballResult, isResultLoading } = useBasketballResult(
        selectedTime[0] || lastWeek[0].month,
        selectedTime[1] || lastWeek[0].date,
    );

    if (isResultLoading) {
        return <PreLoader />;
    }

    if (!basketballResult) {
        return <EmptyMatch />;
    }

    return (
        <LiveScoreGroup selectedSport={selectedSport}>
            {basketballResult
                ?.Result?.Match
                ?.filter((result) => result?.HomeTeam.NameEn && result?.AwayTeam.NameEn
                    && result?.HomeTeam.Icon && result?.AwayTeam.Icon)
                ?.filter(
                    (result) => (
                        // soccer, cricket的比賽狀態是 Status
                        // basketball 的比賽狀態是 MatchStatus
                        result.Status === 50 || result.MatchStatus === 50 || result.Status === 2
                    ),
                )
                ?.slice(0, LiveScoreDisplayCount)
                ?.map((data, bIdx) => {
                    return (
                        <LiveScoreCardResult
                            key={`${data.MatchId}-${bIdx}`}
                            selectedSport="Basketball"
                            sportData={data}
                            isResult
                        />
                    );
                })}
        </LiveScoreGroup>
    );
};
const TennisResult = () => {
    return [];
};
const CricketResult = ({ selectedTime, selectedSport }) => {
    const { lastWeek } = getLastWeek();
    const { cricketResult, isResultLoading } = useCricketResult(
        selectedTime[0] || lastWeek[0].month,
        selectedTime[1] || lastWeek[0].date,
    );

    if (isResultLoading) {
        return <PreLoader />;
    }

    if (!cricketResult) {
        return <EmptyMatch />;
    }

    return (
        <LiveScoreGroup selectedSport={selectedSport}>
            {cricketResult
                ?.Result?.Match
                ?.filter((result) => result?.HomeTeam.Name && result?.AwayTeam.Name
                    && result?.HomeTeam.Icon && result?.AwayTeam.Icon)
                ?.filter(
                    (result) => (
                        // soccer, cricket的比賽狀態是 Status
                        // basketball 的比賽狀態是 MatchStatus
                        result.Status === 50 || result.MatchStatus === 50 || result.Status === 2
                    ),
                )
                ?.slice(0, LiveScoreDisplayCount)
                ?.map((data, cIdx) => {
                    return (
                        <LiveScoreCardResult
                            key={`${data.MatchId}-${cIdx}`}
                            selectedSport="Cricket"
                            sportData={data}
                            isResult
                        />
                    );
                })}
        </LiveScoreGroup>
    );
};

const LiveScoreResult = () => {
    const { t } = useTranslation();
    const [resultSelectedSport, setResultSelectedSport] = useState('Soccer');
    const [soccerSelectedTime, setSoccerSelectedTime] = useState([]);
    const [basketballSelectedTime, setBasketballSelectedTime] = useState([]);
    const [tennisSelectedTime, setTennisSelectedTime] = useState([]);
    const [cricketSelectedTime, setCricketSelectedTime] = useState([]);

    return (
        <>
            <div className="live-score__tab">
                <div className="tabs tabs--pills">
                    <div className="tabs__content">
                        {sportList.map(({ sportName, sportType, i18nKey }) => (
                            <div
                                key={sportName}
                                className="tab"
                                data-selected={resultSelectedSport === sportName}
                                onClick={() => setResultSelectedSport(sportName)}
                            >
                                <a className="btn">
                                    <i className={`icon icon--sport${sportType}`} />
                                    <span className="text">{t(i18nKey)}</span>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="tabs tabs--underline tabs--date" data-open="true">
                    <div className="tabs__content">
                        {{
                            Soccer: <Week
                                selectedTime={soccerSelectedTime}
                                setSelectedTime={setSoccerSelectedTime}
                                resultSelectedSport={resultSelectedSport}
                            />,
                            Basketball: <Week
                                selectedTime={basketballSelectedTime}
                                setSelectedTime={setBasketballSelectedTime}
                                resultSelectedSport={resultSelectedSport}
                            />,
                            Tennis: <Week
                                selectedTime={tennisSelectedTime}
                                setSelectedTime={setTennisSelectedTime}
                                resultSelectedSport={resultSelectedSport}
                            />,
                            Cricket: <Week
                                selectedTime={cricketSelectedTime}
                                setSelectedTime={setCricketSelectedTime}
                                resultSelectedSport={resultSelectedSport}
                            />,
                        }[resultSelectedSport]}
                    </div>
                </div>
            </div>

            {{
                Soccer: <SoccerResult
                    selectedTime={soccerSelectedTime}
                    selectedSport={resultSelectedSport}
                />,
                Basketball: <BasketballResult
                    selectedTime={basketballSelectedTime}
                    selectedSport={resultSelectedSport}
                />,
                Tennis: <TennisResult
                    selectedTime={tennisSelectedTime}
                    selectedSport={resultSelectedSport}
                />,
                Cricket: <CricketResult
                    selectedTime={cricketSelectedTime}
                    selectedSport={resultSelectedSport}
                />,
            }[resultSelectedSport]}
        </>
    );
};

export default LiveScoreResult;
